import { SkillCategory } from '../types';

export const SKILLS_DATA: SkillCategory[] = [
  {
    name: "skills.frontend",
    skills: [
      { name: "JavaScript", category: "frontend" },
      { name: "HTML5", category: "frontend" },
      { name: "CSS", category: "frontend" },
      { name: "React", category: "frontend" },
      { name: "TypeScript", category: "frontend" },
      { name: "Responsive Design", category: "frontend" }
    ]
  },
  {
    name: "skills.backend",
    skills: [
      { name: "Python", category: "backend" },
      { name: "Java", category: "backend" },
      { name: "PHP", category: "backend" },
      { name: "REST APIs", category: "backend" },
      { name: "Database Design", category: "backend" },
      { name: "Server Architecture", category: "backend" }
    ]
  },
  {
    name: "skills.iot",
    skills: [
      { name: "IoT Development", category: "iot" },
      { name: "Embedded Systems", category: "iot" },
      { name: "Sensor Integration", category: "iot" },
      { name: "Energy Management", category: "iot" },
      { name: "Device Communication", category: "iot" },
      { name: "System Monitoring", category: "iot" }
    ]
  },
  {
    name: "skills.tools",
    skills: [
      { name: "Git", category: "tools" },
      { name: "PHPUnit", category: "tools" },
      { name: "Software Testing", category: "tools" },
      { name: "Agile Development", category: "tools" },
      { name: "Code Review", category: "tools" },
      { name: "System Design", category: "tools" }
    ]
  }
];